module.exports = __webpack_public_path__ + "static/media/SS2.4a7c275a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/SS2.jpeg
// module id = 274
// module chunks = 0